<script>
import PortalService from "@/api-services/portal.service";
import QrCodeVue from "qrcode.vue";

export default {
  name: "employeeMfa",
  components: { QrCodeVue },
  props: ["employeeMatricule"],
  data: function () {
    return {
      select: null,
      accountsOtp: [{ otpKeyUrl: "" }],
    };
  },
  methods: {
    getEmployeeMfa: async function () {
      this.tableLoading = true;
      PortalService.getEmployeeAccountsOtp()
        .then((response) => {
          this.accountsOtp = response.data.requestResult;
          this.select = this.accountsOtp[0];
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status == 401) {
              this.$store.commit("setJwt", null);
              this.$store.commit("setIsAuthentified", false);
              this.$router.push("/");
            } else {
              this.$store.commit(
                "setNewErrorMessage",
                error.response.data.requestResult
              );
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$store.commit("setNewErrorMessage", error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$store.commit(
              "setNewErrorMessage",
              error.response.data.requestResult
            );
          }
          console.log(error.response.data);
        });
    },
  },
  computed: {},
  created() {
    if (this.$store.state.isAuthentified) {
      this.getEmployeeMfa();
    }
  },
};
</script>

<template>
  <div id="employeeMfa">
    <v-card flat>
      <v-card-text class="overline pb-0 text-center"
        >Sélectionnez votre compte
      </v-card-text>
      <v-select
        class="mx-10"
        v-model="select"
        :items="accountsOtp"
        return-object
        solo
      >
        <template slot="selection" slot-scope="data">
          <!-- HTML that describe how select should render selected items -->
          {{ data.item.domain }}\{{ data.item.username }}
        </template>
        <template slot="item" slot-scope="data">
          <!-- HTML that describe how select should render items when the select is open -->
          {{ data.item.domain }}\{{ data.item.username }}
        </template>
      </v-select>

      <v-row justify="center" class="mt-n2 mb-3" v-if="select">
        <a :href="select.otpKeyUrl">
          <QrCodeVue :value="select.otpKeyUrl" size="125"></QrCodeVue>
        </a>
      </v-row>
      <v-row justify="center" class="mt-n2 mb-3" v-if="select">{{
        select.otpKey
      }}</v-row>
    </v-card>
  </div>
</template>
